import React from 'react';
import { Form } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/collections/form.less';
import 'semantic-ui-less/definitions/modules/checkbox.less';

export default Form;
